import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import Popup from 'reactjs-popup';
import { PositionType } from '.';
import { Colors } from '../../common/Colors';
import { Variables } from '../../common/Variables';

export const contentStyle = {
  cursor: 'auto',
  zIndex: 1000,
  lineHeight: '1.3',
  fontSize: '1.4rem',
  textAlign: 'left',
  color: Colors.text.default,
  backgroundColor: Colors.ut.bgUp,
  border: 0,
  borderRadius: Variables.tooltipRadius,
  boxShadow: Variables.tooltipShadow
};

export const overlayStyle = {
  cursor: 'auto',
  zIndex: 999,
  opacity: 0,
  animationName: 'none'
};

export const Paragraph = styled('p')`
  margin-top: 0;
  margin-bottom: 0;
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  & + & {
    margin-top: 2rem;
  }

  &:last-child {
    margin-bottom: 0.5rem;
  }
`;

export const ParagraphLink = styled('a')`
  text-decoration: none;
  color: #0b5acd;
  transition: color 0.3s;

  &:hover,
  &:active {
    color: #3187ee;
  }
`;

export const animateTooltip = (position: string) => keyframes`
  from {
    opacity: 0;
    transform: ${
      (position === 'top' && 'translateY(1rem)') ||
      (position === 'bottom' && 'translateY(-1rem)') ||
      (position === 'left' && 'translateX(-1rem)') ||
      (position === 'right' && 'translateX(1rem)')
    };
  }
`;

export const TooltipAnimation = {
  transform: 'translateY(0)',
  animationDuration: '0.3s',
  animationFillMode: 'forwards'
};

function getAnimationDirection(position: PositionType) {
  return animateTooltip(position.split(' ')[0]);
}

interface PopupEmotionProps {
  position: PositionType;
  isArrow: boolean;
}

export const PopupEmotion = styled(Popup)<PopupEmotionProps>`
  animation-name: ${props => getAnimationDirection(props.position)};

  ${props =>
    props.isArrow &&
    css`
      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        width: 1.4rem;
        height: 1.4rem;
        margin: -0.7rem;
        background: ${Colors.ut.bgUp};
        box-shadow: 0.6rem 0.6rem 1rem ${Colors.rgbaBlack3}, 1px 1px 1px rgba(0, 0, 0, 0.12);

        ${(props.position === 'top center' &&
          css`
            top: 100%;
            left: 50%;
            transform: rotate(45deg);
          `) ||
        (props.position === 'top right' &&
          css`
            top: 100%;
            right: 2.9rem;
            transform: rotate(45deg);
          `) ||
        (props.position === 'bottom center' &&
          css`
            top: 0;
            left: 50%;
            transform: rotate(225deg);
          `) ||
        (props.position === 'bottom right' &&
          css`
            top: 0;
            right: 2.9rem;
            transform: rotate(225deg);
          `) ||
        (props.position === 'bottom left' &&
          css`
            top: 0;
            left: 2.9rem;
            transform: rotate(225deg);
          `) ||
        (props.position === 'left center' &&
          css`
            top: 50%;
            left: 100%;
            transform: rotate(-45deg);
          `) ||
        (props.position === 'right center' &&
          css`
            top: 50%;
            left: 0;
            transform: rotate(135deg);
          `)};
      }
    `}
`;
